import React from 'react';
import { Outlet } from 'react-router-dom';
import SiteHeader from '../site-header';
import SiteFooter from '../site-footer';
import { Toaster } from 'react-hot-toast';

export default function AppLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground selection:bg-magenta/40">
      <SiteHeader />
      <main className="flex-1 w-full pt-16">
        <Outlet />
      </main>
      <SiteFooter />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#16121f',
            color: '#f3f0f8',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '12px',
            fontSize: '14px',
          },
          success: { iconTheme: { primary: '#ff7a00', secondary: '#000' } },
        }}
      />
    </div>
  );
}
